import React, { Component } from "react";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom";
import About from "./components/About";
import Home from "./components/Home";
import Navbar from "./components/common/Navbar";
import MEDetail from "./components/MEDetail";

const currentTheme = "light";
class AppWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "Crio.Do Portfolio",
      defaultPath: "/Crio-Launch-Feb-2020-" + process.env.REACT_APP_GITHUB,
      detailPath: "/detail/:meid"
    };
    console.log(this.state.detailPath);
  }

  theme = createMuiTheme({
    palette: {
      primary: {
        main: "#7C8DFF",
        primary: "#7C8DFF",
        primaryBackground: "#F1F4FE",
        primaryBorder: "#D8D8D8",
        white: currentTheme === "light" ? "#fff" : "#000",
        black: "#000000",
        red: "#E66565",
        green: "#70CC63",
        orange: "#E6935A",
        grey: "#999999",
        greyTwo: "#EEEEEE",
        purple: "#570DA8",
        yellow: "#F1C21B"
      },

      secondary: {
        main: "#ffffff",
        secondaryBackground: "#C9D0FF",
        tertiaryBackground: "#F7F7F7"
      }
    }
  });
  getTitle(me) {
    this.setState({ title: this.state.title.concat(me) });
  }
  render() {
    const { classes } = this.props;
    return (
      <Router basename={this.state.defaultPath}>
        <MuiThemeProvider theme={this.theme}>
          <div
            style={{
              backgroundColor: this.theme.palette.secondary.tertiaryBackground,
              height: "100vh",
              overflowX: "scroll"
            }}
          >
            <Navbar title={this.state.title}></Navbar>

            <Switch>
              <Route
                exact
                path={this.state.defaultPath}
                render={() => <Home getTitle={this.getTitle.bind(this)} />}
              ></Route>
              <Route path={this.state.detailPath} component={MEDetail} />
              <Route
                render={() => <Home getTitle={this.getTitle.bind(this)} />}
              ></Route>
            </Switch>
          </div>
        </MuiThemeProvider>
      </Router>
    );
  }
}
export default AppWrapper;
